import React from 'react';
import '../Style/Contact.css';
import QR from '../Images/Kidzee Panchpakhadi.png';

function Contact() {
  const whatsappLink = "https://wa.me/9004141667?text=Hello%2C%20I%20am%20interested%20in%20learning%20more%20about%20the%20programs.";
  return (
    <>
    <section id="contact">
      <div className="container">
        <h2>Contact Us</h2>  
        <div className="contact-us">
       <div className="contact-row">
        {/* Column 1: Phone Icon with Number and Instagram */}
        <div className="contact-column">
          <i className="fas fa-phone-alt contact-icon"></i>
          <p>+91 9004141667</p>
          <a href="https://www.instagram.com/kidzee.panchpakhadi?igsh=MTVwdXZiZjV2ZTVvYw==" target="_blank" rel="noopener noreferrer" className="contact-link">
            <i className="fab fa-instagram contact-instagram"></i> Instagram
          </a>
          <br/>
          <a
              href="https://www.facebook.com/profile.php?id=61572634150282"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              <i className="fab fa-facebook-f contact-facebook"></i> Facebook
            </a>
            <br />
            <a
              href="https://linktr.ee/kidzee.panchpakhadi"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              <i className="fab fa-linktree contact-linktree"></i> Linktree
            </a>
        </div>

        {/* Column 2: Address with Home Icon and Live Chat */}
        <div className="contact-column">
          <i className="fas fa-home contact-icon"></i>
          <p>104/105, First Floor Sachinam Chs Opposite Neuron, Ad. Almeida Road, Panchpakhadi, Thane(w) - 400602</p>
          
        </div>

        {/* Column 3: Chat Icon with Live Chat */}
        <div className="contact-column">
          <i className="fas fa-comment-dots contact-icon"></i>
          <p>Start a conversation</p>
          <button className="chat-button">
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="whatsapp-link"
            >
              Chat Now
            </a>
          </button>
        </div>
      </div>
    </div>
    
      </div>
    </section>
    <span class="footer-content">
    <p>@ 2025 kidzee panchpakhadi. All rights reserved.</p>
  </span>
  </>
  );
}

export default Contact;